import {
  format,
  formatDistanceToNowStrict,
  isAfter,
  isBefore,
  FormatDistanceToNowStrictOptions,
  subDays,
  differenceInMilliseconds,
  differenceInCalendarDays,
} from 'date-fns'

export function getDistanceToNowStrict(date: string | Date, options?: FormatDistanceToNowStrictOptions) {
  const now = new Date()
  const distanceInSeconds = Math.abs((new Date(date).getTime() - now.getTime()) / 1000)

  if (distanceInSeconds < 60) {
    return 'now'
  }
  return formatDistanceToNowStrict(date, options)
}

export function getFormattedDate(date: string | Date) {
  return format(new Date(date), 'dd/MM/yyyy')
}

export function getFormattedDateTime(date: string | Date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm')
}

export function getDifferenceInCalendarDaysFromToday(date?: Date | string | null) {
  if (!date) return 0
  const laterDate = new Date(date)
  const today = new Date()

  return differenceInCalendarDays(laterDate, today)
}

export function isAfterToday(date: string | Date) {
  return isAfter(new Date(date), new Date())
}

export function isMoreThanOneMonthBeforeToday(date: string | Date) {
  return isBefore(new Date(date), subDays(new Date(), 30))
}

export function isBeforeToday(date: string | Date) {
  return isBefore(date, subDays(Date.now(), 1))
}

export function calculateDateProgress(startDate: Date | null, closeDate: Date | null): number {
  if (!startDate || !closeDate) return 0

  const today = new Date()
  if (isAfter(today, closeDate)) return 100
  if (isBefore(today, startDate)) return 0

  const totalDuration = differenceInMilliseconds(closeDate, startDate)
  const elapsedDuration = differenceInMilliseconds(today, startDate)
  const progress = (elapsedDuration / totalDuration) * 100

  return Math.min(Math.max(Math.round(progress * 100) / 100, 0), 100)
}

export const standardizeDate = (date?: Date | null): Date | null => {
  if (!date) return null
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0))
}
